/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'
import deprecate from '../../utils/deprecate'

class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      
<svg width="20" height="18" viewBox="0 0 20 18" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  
  <path d="M0,16.36 L19.6,16.339 L9.774,0 L0,16.36 Z M17.832,15.341 L1.764,15.358 L9.777,1.945 L17.832,15.341 Z M9.212,6.233 L10.212,6.233 L10.212,10.699 L9.212,10.699 L9.212,6.233 Z M9.747,13.387 C10.2076055,13.387 10.581,13.0136055 10.581,12.553 C10.581,12.0923945 10.2076055,11.719 9.747,11.719 C9.28639452,11.719 8.913,12.0923945 8.913,12.553 C8.913,13.0136055 9.28639452,13.387 9.747,13.387 Z" className="icon-fill"/>
</svg>

    )
  }
}

Icon.displayName = 'AlertStrokeIcon'

export default deprecate({message: 'Please use AlertStrokeIcon. ', name: Icon.displayName})(Icon)
